import apiClient, { ApiResponse } from './client';

export interface CartesiaVoice {
  id: string;
  name: string;
  description: string | null;
  language: string | null;
  gender: string | null;
  is_public: boolean | null;
  preview_available: boolean;
}

export interface CartesiaVoiceCatalogResponse {
  voices: CartesiaVoice[];
}

const cartesiaService = {
  listVoices(): Promise<ApiResponse<CartesiaVoiceCatalogResponse>> {
    return apiClient.get<CartesiaVoiceCatalogResponse>('/api/integrations/cartesia/voices');
  },
};

export default cartesiaService;
